import React, { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { toast, ToastContainer } from "react-toastify";
import {useNavigate} from 'react-router-dom';
import { ArrowBigLeft, History, Smile } from 'lucide-react';
import { getLastHistory } from '../../services/tableServices';

import "./Game.scss";
import rever from "../../styles/image/rever.png";
import jeton from "../../styles/image/jeton.png";
import jetonMany from "../../styles/image/jetonMany.png";
import tableTexture from "../../styles/image/vert_table.png";

import PlayerActions from './PlayerActions';
import Player from './Player';
import CommunityCards from './CommunityCards';
import Pots from './Pots';
import SoundButton from './SoundButton';
import GameHistoryModal from './GameHistoryModal';
import { onlineUsersSocket } from '../../engine/socket';
import Confetti from 'react-confetti';

import TableTabs from './TableTabs';
import TableChat from './TableChat';
import RecaveModal from './RecaveModal';
import { PlusCircle } from 'lucide-react';
const Game = ({tableId, tableSessionIdShared, setTableSessionId, cavePlayer }) => {
    const [tableState, setTableState] = useState({});
    const [frozenStacks, setFrozenStacks] = useState(null);
    const lastStableSeatsRef = useRef(null);
    const [isRecaveModalOpen, setIsRecaveModalOpen] = useState(false);
    const [betSize, setBetSize] = useState(0);
    const [winData, setWinData] = useState({});
    const [showConfetti, setShowConfetti] = useState(false);
    const [sb, setSb] = useState(-1);
    const [bb, setBb] = useState(-1);
    const [dealer, setDealer] = useState(-1);
    const [game, setGame] = useState(false);
    const socketRef = useRef(null);
    const navigate = useNavigate();
    const playerCave = Number(cavePlayer) || 0;
    const [community, setCommunity] = useState([]);
    const [communityShow, setCommunityShow] = useState([]);
    const [isRevealFinished, setIsRevealFinished] = useState(false);
    const foldedPlayers = useRef(new Set());
    const isPossibleAction = useRef(true);
    const [soundMute, setSoundMute] = useState(false);
    const [avatars, setAvatars] = useState([]);
    const tableRef = useRef(null);
    const playerRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];
    const [shouldShareCards, setShouldShareCards] = useState(false);
    const [sharingCards, setSharingCards] = useState(false);
    const [communityReversNb, setCommunityReversNb] = useState(0);
    let latestCommCard = null;
    const [moveCommCards, setMoveCommCards] = useState(false);
    const [communityToShow, setCommunityToShow] = useState([]);
    const [allInArr, setAllInArr] = useState([]);
    const [gameOver, setGameOver] = useState(false);
    const potRef = useRef(null);
    const [hideStack, setHideStack] = useState(false)
    const [winAllIn, setWinAllIn] = useState(false)
    const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false)
    const [lastMatchHistory, setLastMatchHistory] = useState(null)
    const quitRedirectTimerRef = useRef(null);

    
    useEffect(() => {
        const socket = io(process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000');
        socketRef.current = socket;

        const userId = sessionStorage.getItem('userId');
        const username = sessionStorage.getItem('userName'); // ✅ FIX: 'userName' pas 'username'

        // Rejoindre la table
        socket.emit('join_table', { tableId, userId, username });

        // ✅ CLEANUP CORRECT
        return () => {
            // Émettre que l'utilisateur quitte la table (événement custom)
            socket.emit('leave_table', { tableId, userId });
            
            // Déconnexion propre
            socket.disconnect(); // ✅ Pas socket.emit('disconnect')
        };
    }, [tableId]);
    /**
     * Plays sound
     * 
     * @param {string} type 
     * @param {bool} soundMute 
     */
    const playSound = (type, soundMute) => {
      const sounds = {
        fold: '/sounds/fold.mp3',
        raise: '/sounds/raise.mp3',
        check: '/sounds/check.mp3',
        call: '/sounds/call.wav',
        join: '/sounds/join.mp3',
        allin: '/sounds/allin.mp3',
        win: '/sounds/win.wav',
        shareCards: '/sounds/share-cards.mp3',
        showCard: '/sounds/show-card.wav',
        coinWin: '/sounds/coin-win.wav',
      };
      
      if (!soundMute) {
        const audio = new Audio(sounds[type]);
        audio.play().catch(() => {});
      }
    }
    // Dans le composant Game, ajoutez avant le return :
    const currentUserId = sessionStorage.getItem('userId');
    
    /**
     * rand just utils function to get random number
     */
    function rand(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    
    useEffect(() => {
        const diff = community.length - communityShow.length;
        setIsRevealFinished(false);   

        if (diff <= 0){
            setIsRevealFinished(true); 
            return;
        }

        if (diff === 3){
            setCommunityShow(community);
            setTimeout(() => {
                setCommunityToShow(community);
            }, 100);
            setIsRevealFinished(true);
            return;
        }

        setIsRevealFinished(false);

        if (diff === 1) {
            setCommunityShow(community);
            setTimeout(() => {
                setCommunityToShow(community);
            }, 100);
            setIsRevealFinished(true);
            return;
        }

        const timeouts = [];
        if (diff > 1) {
            let timeindex = 0;
            for(let i = communityShow.length; i < community.length; i++) {
                const newShowCards = community.slice(0, i + 1);
                
                const timeout = setTimeout(() => {
                    setTimeout(() => {
                        setCommunityShow(newShowCards);
                        setTimeout(() => {
                            setCommunityToShow(prev => [...prev, newShowCards[i]]);
                        }, 100);
                    }, 500);
                    if (i + 1 === community.length) {
                        setIsRevealFinished(true);
                    }
                }, (timeindex * 1000));

                timeouts.push(timeout);
                timeindex ++;
            }
        }
        return () => {
            timeouts.forEach(t => clearTimeout(t));
        };
    }, [community]);

    useEffect(() => {
        const userId = sessionStorage.getItem('userId');
        if(!tableId) return;

        socketRef.current = io(process.env.REACT_APP_BASE_URL, {
            auth: {
                token: sessionStorage.getItem("accessToken"),
            },
        });

        socketRef.current.on('connect', () => {
            if(!tableSessionIdShared) {
                playSound('join', soundMute);
                socketRef.current.emit('joinAnyTable', { tableId, userId, playerCave });

                onlineUsersSocket.emit('joined-tables:join', { uid: parseInt(userId), tid: parseInt(tableId) });
            }else {           
                socketRef.current.emit('joinTableSession',{ tableId, tableSessionId: tableSessionIdShared, userId, playerCave });
            }
        });

        socketRef.current.on('playerActionError', (data) => {
            // Restore the normal server-driven display if the all-in was refused.
            setFrozenStacks(null);
            toast.error(data.message || "Une erreur est survenue.");
        });


        socketRef.current.on('joinError', (data) => {
            toast.error(data.message);
            
            // Forcer la sortie immédiate côté serveur pour que les adversaires voient le départ
            quitter(true);
        });

        socketRef.current.on('win', (data) => {
            // Reset before applying the result so stacks remain frozen while the
            // community-card reveal effect starts.
            setIsRevealFinished(false);
            setGameOver(true);
            
            setGame(false);
            setCommunity(data.communityCards);
            
            setShouldShareCards(false);
            
            setWinData(data);
            
            // Sauvegarder l'historique du dernier match
            // Convertir le Set en Array pour la sérialisation
            const foldedPlayersArray = Array.from(foldedPlayers.current);
            
            setLastMatchHistory({
                communityCards: data.communityCards || [],
                allCards: data.allCards || [],
                playerNames: [],
                foldedPlayers: foldedPlayersArray
            });
            
            playSound('win', soundMute);
        });

        async function shareCardsHandler() {
            function sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            }
            setGameOver(false);
            setWinData({});
            setCommunity([]);
            setCommunityShow([]);
            setCommunityToShow([]);
            setAllInArr([]);
            setFrozenStacks(null);
            
            setShouldShareCards(true);
            setTimeout(async () => {
                setSharingCards(true);
                const playerIds = tableState.playerIds?.filter(id => id !== null);
                playSound('shareCards');
            }, 300);
        }
        socketRef.current.on('shareCards', shareCardsHandler);

        socketRef.current.on('start', () => {
            setWinData({});
            setGame(true);
            setCommunity([]);
            setCommunityShow([]);
            setAllInArr([]);
            setFrozenStacks(null);
            foldedPlayers.current = new Set();

            setShouldShareCards(false);
            setSharingCards(false);
        });

        socketRef.current.on('tableState', (data) => {
            const lastAction = data?.actions?.[data.actions.length - 1];
            const allInSeat = lastAction?.playerId;
            const stackBeforeAction = lastStableSeatsRef.current?.[allInSeat];
            const isAllIn = lastAction?.action === 'raise' && (
                data?.seats?.[allInSeat]?.stack === 0 ||
                (Number.isFinite(Number(stackBeforeAction)) &&
                    Number(lastAction?.amount) >= Number(stackBeforeAction))
            );

            // Keep the all-in display separate from the server's final stack.
            if (isAllIn) {
                // The all-in player's visible stack is immediately 0: their full
                // stack has gone into the pot. Other players keep receiving their
                // remaining stacks while they call or raise.
                setFrozenStacks(current => {
                    const next = current ? [...current] : [];
                    next[allInSeat] = 0;
                    return next;
                });
            } else if (Array.isArray(data?.seats)) {
                lastStableSeatsRef.current = data.seats.map(seat => seat?.stack);
            }
            const minBet = data?.legalActions?.chipRange?.min ?? 0;
            setBetSize(minBet);
            setTableState({ ...data });
            setTableSessionId(data.tableId);
            
            setAvatars(data.avatars);

            if(data.communityCards.length > 0) {
                if (latestCommCard !== data.communityCards[data.communityCards.length -1]) {
                    if (data.communityCards.length === 3) {
                        setCommunityReversNb(3);
                    } else {
                        setCommunityReversNb(1);
                    }
                    setTimeout(() => {
                        setMoveCommCards(true);
                    }, 100);
                }
                setTimeout(() => {
                    setMoveCommCards(false);
                    setCommunity(data.communityCards);
                    setCommunityReversNb(0);
                    latestCommCard = data.communityCards[data.communityCards.length -1];
                }, 500);
            }

            if(data.toAct == data.seat) {
                isPossibleAction.current=true;
            }

            for(const item of (data?.actions ?? [])) {
                if(item.action === 'fold') {
                    foldedPlayers.current.add(item.playerId)
                }
            }
            
            if (lastAction) {
                const playerId = lastAction?.playerId;
                const seatInfo = data?.seats[playerId];
                
                if (isAllIn) {
                  playSound('allin', soundMute);
                  setAllInArr(prev => [...prev, seatInfo]);
                  return;
                }
                playSound(lastAction.action, soundMute);
            }
        });

        socketRef.current.on('quitsuccess', () => {
            if (quitRedirectTimerRef.current) {
                clearTimeout(quitRedirectTimerRef.current);
                quitRedirectTimerRef.current = null;
            }
      //      sessionStorage.removeItem('lastTableId_'+userId);
             localStorage.removeItem(`lastTableId_${userId}`);
            finalizeQuit();
        });

        socketRef.current.on('quiterror', () => {
            quitter();
        });

        socketRef.current.on('rebuyError', (data) => {
            toast.error(data.message || "Erreur lors de la recave.");
            if (data.message === 'Solde insuffisant' || data.message?.includes('Solde insuffisant')) {
                // sessionStorage.removeItem('lastTableId_'+userId);
                localStorage.removeItem(`lastTableId_${userId}`);
                quitter(true); // Force quit immédiat
            }
        });

        socketRef.current.on('timeerror', (data) => {
            // Le serveur refuse la sortie (temps minimum non écoulé) :
            // annuler la redirection de secours programmée par quitter().
            if (quitRedirectTimerRef.current) {
                clearTimeout(quitRedirectTimerRef.current);
                quitRedirectTimerRef.current = null;
            }
            toast.info(`Vous ne pouvez pas quitter. Temps restant : ${data.formatted}`, {
                autoClose: 10000
            });
        });


        return () => {
            if (quitRedirectTimerRef.current) {
                clearTimeout(quitRedirectTimerRef.current);
                quitRedirectTimerRef.current = null;
            }
            socketRef.current?.disconnect();
            socketRef.current = null;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableId, soundMute, winAllIn]);

    useEffect(() => {
        if (gameOver && isRevealFinished && winData?.winStates?.some(w => w.isWinner)) {
            setShowConfetti(true);
            const timer = setTimeout(() => setShowConfetti(false), 4500);
            return () => clearTimeout(timer);
        } else {
            setShowConfetti(false);
        }
    }, [gameOver, isRevealFinished, winData]);

    useEffect(() => {
        if (!game || !tableState.activeSeats) return;

        const activeSeats = tableState.activeSeats;
        const dealerSeat = tableState.deal_btn;
        const playerCount = activeSeats.length;

        const dealerIdx = activeSeats.indexOf(dealerSeat);
        if (dealerIdx === -1) return;

        let sbSeat, bbSeat;
        if (playerCount === 2) {
            sbSeat = dealerSeat;
            bbSeat = activeSeats[(dealerIdx + 1) % playerCount];
        } else {
            sbSeat = activeSeats[(dealerIdx + 1) % playerCount];
            bbSeat = activeSeats[(dealerIdx + 2) % playerCount];
        }

        // Ne set que si pas déjà définis
        if (sb === -1) setSb(sbSeat);
        if (bb === -1) setBb(bbSeat);
        if (dealer === -1) setDealer(dealerSeat);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [game, tableState]);

    useEffect(() => {
        setSb(-1);
        setBb(-1);
        setDealer(-1);    
    }, [game]);

    // Récupérer le dernier historique depuis l'API
    useEffect(() => {
        const fetchLastHistory = async () => {
            if (!tableId) return;
            
            try {
                const historyData = await getLastHistory(tableId);
                
                // Adapter les données de l'API au format attendu
                if (historyData) {
                    // Convertir les joueurs qui ont foldé en Array si nécessaire
                    let foldedPlayersArray = [];
                    if (historyData.foldedPlayers) {
                        foldedPlayersArray = Array.isArray(historyData.foldedPlayers) 
                            ? historyData.foldedPlayers 
                            : Array.from(historyData.foldedPlayers);
                    } else if (historyData.foldes) {
                        // Si l'API retourne 'foldes' au lieu de 'foldedPlayers'
                        foldedPlayersArray = Array.isArray(historyData.foldes) 
                            ? historyData.foldes 
                            : (typeof historyData.foldes === 'string' 
                                ? JSON.parse(historyData.foldes) 
                                : []);
                    }
                    
                    // Parser les données si elles sont en string JSON
                    let parsedAllCards = historyData.allCards || historyData.main_joueurs || [];
                    let parsedPlayerNames = historyData.playerNames || historyData.noms_joueurs || [];
                    
                    // Si les données sont en string JSON, les parser
                    if (typeof parsedAllCards === 'string') {
                        try {
                            parsedAllCards = JSON.parse(parsedAllCards);
                        } catch (e) {
                            console.error('Error parsing allCards:', e);
                        }
                    }
                    
                    if (typeof parsedPlayerNames === 'string') {
                        try {
                            parsedPlayerNames = JSON.parse(parsedPlayerNames);
                        } catch (e) {
                            console.error('Error parsing playerNames:', e);
                        }
                    }
                    
                    setLastMatchHistory({
                        communityCards: historyData.communityCards || historyData.cartes_communes || [],
                        allCards: parsedAllCards,
                        playerNames: parsedPlayerNames,
                        foldedPlayers: foldedPlayersArray,
                        // Garder aussi les données brutes au cas où le format serait différent
                        playerNamesMap: historyData.playerNamesMap || historyData.noms_joueurs_map || null
                    });
                }
            } catch (error) {
                console.error('Error fetching last history:', error);
                // En cas d'erreur, on ne fait rien (pas de données fictives)
            }
        };

        fetchLastHistory();
    }, [tableId]);

    // Timer pour quitter automatiquement si le tapis est vide et qu'on ne recave pas
    const [autoQuitTimer, setAutoQuitTimer] = useState(null);

    // Automatically open recave modal when stack is 0
    useEffect(() => {
        if (!tableState.seats || tableState.seat === undefined || tableState.seat === null) return;

        const playerSeat = tableState.seats[tableState.seat];
        
        if (playerSeat && playerSeat.stack === 0 && gameOver && !tableState.handInProgress) {
            setTimeout(() => {
                setIsRecaveModalOpen(true);
            }, 7000);
        } else {
            setIsRecaveModalOpen(false);
        }
    }, [tableState, gameOver]);

    const emitPlayerAction = (action, betSizeParam = undefined) => {
        const userId = sessionStorage.getItem('userId');
        if (!isPossibleAction.current) return;

        isPossibleAction.current = false;

        const betSizeSend = betSizeParam ? betSizeParam : betSize;
        const { min, max } = tableState.legalActions.chipRange;
        const clampedBet = Math.max(min, Math.min(betSizeSend, max));

        // The Tapis button sends a raise equal to the maximum legal amount.
        // Freeze this seat at zero immediately, before the next socket state.
        if (action === 'raise' && Number(clampedBet) === Number(max)) {
            const allInSeat = tableState.seat;
            setFrozenStacks(current => {
                const next = current ? [...current] : [];
                next[allInSeat] = 0;
                return next;
            });
        }
        const key= `players_stacks_${tableId}_${tableState.seat}_${userId}`;
        sessionStorage.setItem(key, (parseInt(tableState.seats[tableState.seat].stack)));
        let actionTrue = action;
        socketRef.current.emit('playerAction', {
            tableId: tableId,
            tableSessionId: tableState.tableId, 
            playerSeats: tableState.seat, 
            action: actionTrue, 
            bet: clampedBet
        });
    }

    const quitter = (force = false) => {
        if (quitRedirectTimerRef.current) {
            clearTimeout(quitRedirectTimerRef.current);
        }
        socketRef.current.emit("quit", {
            tableId: tableId,
            tableSessionId: tableState.tableId,
            playerSeats: tableState.seat,
            force: force // Ajout du paramètre force
        });
        const userId = sessionStorage.getItem('userId');
        onlineUsersSocket.emit('leave_table', { userId: parseInt(userId), tableId: parseInt(tableId) });
        
        // Nettoyage complet du session storage
        sessionStorage.removeItem('lastTableId');
        // Si vous avez d'autres clés spécifiques aux tables, ajoutez-les ici :
        // sessionStorage.removeItem('autreCle')
        
        // Dispatch d'un événement pour avertir les autres composants de la sortie
        window.dispatchEvent(new Event('tableLeft'));

        // Redirection de secours : si quitsuccess ne revient pas dans 3s, on redirige quand même
        quitRedirectTimerRef.current = setTimeout(() => {
            quitRedirectTimerRef.current = null;
            finalizeQuit();
        }, 3000);
    };

    function finalizeQuit() {
        navigate('/acceuil');
    }

    const handleRecave = (amount) => {
        if (!socketRef.current) return;

        const numericAmount = Number(amount);
        if (isNaN(numericAmount) || numericAmount <= 0) return;

        // ✅ Annuler immédiatement le timer d'expulsion automatique pour éviter l'expulsion en cas de latence réseau
        if (autoQuitTimer) {
            clearTimeout(autoQuitTimer);
            setAutoQuitTimer(null);
        }

        // Stocker le montant dans le sessionStorage
        sessionStorage.setItem(`recave_amount_${tableId}`, numericAmount);

        socketRef.current.emit('rebuy', {
            tableId: tableId,
            tableSessionId: tableState.tableId,
            amount: numericAmount
        });
    };

    const getSrcCard = (card_id) => {
        const final_id_card = card_id.replace('T', 0).toUpperCase();
        return require(`../../image/card2/${final_id_card}.svg`);  
    };

    const actionLabels = {
        fold: 'Se coucher',
        check: 'Parole',
        call: 'Suivre',
    };

    const addRange = () => {
        setBetSize(Math.min((betSize + 10 ), tableState.legalActions.chipRange.max));
    }

    const minusRange = () => {
        setBetSize(Math.max((betSize - 1 ), tableState.legalActions.chipRange.min));
    }

    return (
        <div key={tableId} className="game-container">
            <ToastContainer />
            {showConfetti && (
                <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 99999, overflow: 'hidden' }}>
                    <Confetti numberOfPieces={120} recycle={false} width={400} height={720} gravity={0.25} />
                </div>
            )}
          
            {tableState.handInProgress && tableState.toAct === tableState.seat && ( 
                <PlayerActions
                    tableState={tableState}
                    betSize={betSize}
                    setBetSize={setBetSize}
                    emitPlayerAction={emitPlayerAction}
                    addRange={addRange}
                    minusRange={minusRange}
                />
            )}

            <CommunityCards
                key={tableId}
                community={community}
                communityShow={communityShow}
                communityToShow={communityToShow}
                communityReversNb={communityReversNb}
                moveCommCards={moveCommCards}
                gameOver={gameOver}
                allInArr={allInArr}
                winData={winData}
                getSrcCard={getSrcCard}
                playSound={playSound}
                soundMute={soundMute}
                isRevealFinished={isRevealFinished}
                tableId={tableId}
            />
            
            <Pots
                tableState={tableState}
                jetonMany={jetonMany}
                jeton={jeton}
                potRef={potRef}
                playerRefs={playerRefs}
                animatePotToWinner={isRevealFinished && winData?.winStates?.some(w => w.isWinner)}
                winnerSeats={winData?.winStates?.filter(w => w.isWinner).map(w => w.seat) || []}
                playSound={playSound}
                shouldShareCards={shouldShareCards}
            />

            <div 
                className="table"
                ref={tableRef}
                style={{
                  marginTop: 10,
                }}
            >
                <div 
                    className="table-surface"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <img 
                        src={tableTexture} 
                        alt=""
                        style={{
                            width: 'calc(408px)',
                            height: 'calc(650px)',
                            objectFit: 'contain',
                            padding: '1rem',
                            mixBlendMode: 'multiply', // Retire le blanc
                            filter: 'contrast(1.1)' // Améliore le contraste
                        
                        }}
                    />
                    {shouldShareCards && (
                        <div style={{
                            position: 'absolute',
                            width: '40pt',
                            height: '56pt',
                            backgroundColor: '#fff',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                            boxShadow: '2px 2px 5px rgba(0,0,0,0.3)'
                        }}>
                            <img src={rever} alt="Deck" style={{width: '100%', height: '100%'}} />
                        </div>
                    )}
                    
                </div>
                {tableState.seats && (tableState.seats).map((chips, i) => {
                    return (
                        <Player
                            key={i}
                            i={i}
                            chips={chips}
                            frozenStack={frozenStacks?.[i]}
                            tableState={tableState}
                            winData={winData}
                            sb={sb}
                            bb={bb}
                            dealer={dealer}
                            avatars={avatars}
                            playerRefs={playerRefs}
                            tableRef={tableRef}
                            getSrcCard={getSrcCard}
                            rever={rever}
                            foldedPlayers={foldedPlayers}
                            shouldShareCards={shouldShareCards}
                            sharingCards={sharingCards}
                            allInArr={allInArr}
                            isRevealFinished={isRevealFinished}
                            gameOver={gameOver}
                            hideStack={hideStack}
                            tableId={tableId}
                        />
                    );
                })}
            </div>

            {!tableState.handInProgress && (
                <div 
                    className="exit" 
                    onClick={() => quitter()}
                    style={{
                      padding: '4px 8px 4px 8px', 
                      background: '#ff3030ff',
                      color: '#FFF',
                    }}
                >
                    <ArrowBigLeft size={24} style={{ marginRight: 0 }} />
                    Quitter
                </div>
            )}

            <div
                style={{
                    position: 'absolute',
                    top: '2%',
                    right: '5%',
                    display: 'flex',
                    gap: '12px',
                    zIndex: 999,
                }}
            >
                <div style={{
                    display: 'flex'
                }}>
                    <TableTabs />
                </div>

                <SoundButton soundMute={soundMute} setSoundMute={setSoundMute} />
                
                <div 
                    className="" 
                    onClick={() => setIsHistoryModalOpen(true)}
                    style={{
                        color: '#FFD700',
                        cursor: 'pointer',
                        borderRadius: 4,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 32,
                        paddingTop: 4,
                        paddingBottom: 4,
                        border: '2px solid #FFD700',
                    }}
                >
                    <History size={20} />
                    {/* <span>Historique</span> */}
                </div>
            </div>
            
            <RecaveModal 
                isOpen={isRecaveModalOpen} 
                onClose={() => setIsRecaveModalOpen(false)} 
                onRecave={handleRecave}
                onQuit={() => quitter(true)}
                minCave={tableState.legalActions?.chipRange?.min || sessionStorage.getItem('amount_cave_' + tableId) || 0} 
                defaultCave={tableState.legalActions?.chipRange?.min || sessionStorage.getItem('amount_cave_' + tableId) || 0}
            />

            <GameHistoryModal 
                isOpen={isHistoryModalOpen}
                onClose={() => setIsHistoryModalOpen(false)}
                lastMatchData={lastMatchHistory}
                getSrcCard={getSrcCard}
                playerNames={tableState.playerNames || []}
            />
            {/* Ajoutez le chat ici */}
                <TableChat 
                    socketRef={socketRef}
                    tableId={tableId}
                    tableState={tableState} // Ajoutez ceci
                    currentUserId={currentUserId}
                    playerNames={tableState.playerNames || []}
                />
        </div>
    );
};

export default Game;
